import script from "./TreeComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./TreeComponent.vue?vue&type=script&setup=true&lang=ts"

import "./TreeComponent.vue?vue&type=style&index=0&id=1db09630&scoped=true&lang=scss"

import exportComponent from "/builds/boikovky/pro2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1db09630"]])

export default __exports__